// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1OKMP","productName":"Table_productName__3YqdY"};